import { useState } from "react";
import {
    TicketPercent,
    CheckCircle2,
    XCircle,
    Loader2,
    Trash2,
} from "lucide-react";
import "./DiscountCode.css";
import { usePayment } from "../../../../../context/PaymentContext";


export default function DiscountCode() {

    const {

        couponData,
        couponCode,
        setCouponCode,
        couponLoading,
        couponStatus,
        couponMessage,
        applyCoupon,
        removeCoupon,

    } = usePayment();


    /*
    |--------------------------------------------------------------------------
    | Local input
    |--------------------------------------------------------------------------
    */

    const [inputCode, setInputCode] =
        useState(couponCode || "");


    /*
    |--------------------------------------------------------------------------
    | Apply
    |--------------------------------------------------------------------------
    */

    const handleApply = async () => {

        if (couponLoading) {
            return;
        }

        if (couponData?.coupon) {
            return;
        }


        const normalizedCode =
            inputCode.trim();


        if (!normalizedCode) {
            return;
        }


        const success =
            await applyCoupon(
                normalizedCode
            );


        if (success) {

            setInputCode(
                couponCode ||
                normalizedCode
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Remove
    |--------------------------------------------------------------------------
    */

    const handleRemove = () => {
        removeCoupon();
        setInputCode("");

    };


    /*
    |--------------------------------------------------------------------------
    | Enter
    |--------------------------------------------------------------------------
    */

    const handleKeyDown = (event) => {

        if (
            event.key === "Enter" &&
            !couponLoading &&
            !couponData?.coupon
        ) {

            event.preventDefault();

            handleApply();

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Render
    |--------------------------------------------------------------------------
    */

    return (

        <section
            className="discount-card"
            dir="rtl"
        >

            <div className="discount-header">

                <div className="discount-title-wrapper">

                    <div className="discount-icon">

                        <TicketPercent
                            size={21}
                        />

                    </div>

                    <div>

                        <h3>
                            کد تخفیف
                        </h3>

                        <span>
                            کد تخفیف خود را وارد کنید
                        </span>

                    </div>

                </div>

            </div>


            {/* =================================================
                INPUT
            ================================================= */}

            {!couponData?.coupon && (

                <div className="discount-input-row">

                    <input
                        type="text"
                        id="couponCode"
                        value={
                            inputCode
                        }

                        placeholder="کد تخفیف را وارد کنید"

                        disabled={
                            couponLoading
                        }

                        autoComplete="off"

                        onChange={(event) => {

                            setInputCode(
                                event.target.value
                            );

                        }}

                        onKeyDown={
                            handleKeyDown
                        }

                    />


                    <button

                        type="button"

                        className="apply-coupon"

                        disabled={
                            couponLoading ||
                            !inputCode.trim()
                        }

                        onClick={
                            handleApply
                        }

                    >

                        {couponLoading ? (

                            <>

                                <Loader2
                                    size={18}
                                    className="spin"
                                />

                                <span>
                                    در حال بررسی...
                                </span>

                            </>

                        ) : (

                            "اعمال"

                        )}

                    </button>

                </div>

            )}


            {/* =================================================
                APPLIED COUPON
            ================================================= */}

            {couponData?.coupon && (

                <div className="applied-coupon">

                    <div className="applied-coupon-content">

                        <div className="coupon-check">

                            <CheckCircle2
                                size={21}
                            />

                        </div>


                        <div className="coupon-details">

                            <strong>

                                {
                                    couponData
                                        .coupon
                                        .title ||
                                    "کد تخفیف"
                                }

                            </strong>


                            <span>

                                کد:

                                {" "}

                                {
                                    couponData
                                        .coupon
                                        .code
                                }

                            </span>


                            <small>

                                {
                                    couponMessage ||
                                    "کد تخفیف با موفقیت اعمال شد."
                                }

                            </small>

                        </div>

                    </div>


                    <button

                        type="button"

                        className="remove-coupon"

                        title="حذف کد تخفیف"

                        onClick={
                            handleRemove
                        }

                    >

                        <Trash2
                            size={18}
                        />

                        <span>
                            حذف
                        </span>

                    </button>

                </div>

            )}


            {/* =================================================
                SUCCESS
            ================================================= */}

            {couponStatus === "success" &&
                !couponData?.coupon && (

                    <div className="coupon-success">

                        <CheckCircle2
                            size={18}
                        />

                        <span>
                            {couponMessage}
                        </span>

                    </div>

                )}


            {/* =================================================
                ERROR
            ================================================= */}

            {couponStatus === "error" && (

                <div className="coupon-error">

                    <XCircle
                        size={18}
                    />

                    <span>
                        {couponMessage}
                    </span>

                </div>

            )}

        </section>

    );

}